var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#D7D7D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3988 11.7788C19.7331 11.0083 21.5056 10.7955 23.0368 11.2437C26.3676 12.2247 27.4016 15.5411 26.4768 18.18C25.0497 22.3246 18.9552 25.4161 18.6967 25.5458C18.6048 25.5922 18.503 25.6155 18.4013 25.6155C18.2995 25.6155 18.1986 25.593 18.1067 25.5473C17.8498 25.4191 11.7995 22.3733 10.3249 18.1807C10.3241 18.1807 10.3241 18.18 10.3241 18.18C9.39847 15.5404 10.4291 12.2232 13.7567 11.2437C15.3191 10.782 17.0218 10.9851 18.3988 11.7788ZM14.1341 12.3139C11.4418 13.1068 10.7656 15.7517 11.4967 17.8375C12.6472 21.1067 17.1925 23.7501 18.4004 24.4043C19.6125 23.7433 24.1906 21.0707 25.3041 17.8405C26.0353 15.7525 25.3566 13.1076 22.6602 12.3139C21.3538 11.9309 19.8299 12.164 18.7779 12.9075C18.558 13.0619 18.2527 13.0649 18.0312 12.912C16.9168 12.1468 15.461 11.9227 14.1341 12.3139ZM21.8724 13.8023C22.9909 14.1328 23.7745 15.0374 23.8705 16.1069C23.8976 16.4164 23.6457 16.6877 23.3068 16.7125C23.2896 16.714 23.2731 16.7147 23.2559 16.7147C22.9383 16.7147 22.6692 16.4921 22.6429 16.1983C22.5888 15.5823 22.1374 15.0621 21.4949 14.8725C21.1708 14.7766 20.9935 14.4596 21.0977 14.165C21.2036 13.8697 21.5474 13.7093 21.8724 13.8023Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeBg);
export default __webpack_public_path__ + "static/media/like_bg.6778a8020fdd48cd881d2cc933b63cda.svg";
export { ForwardRef as ReactComponent };